import { AfterViewInit, Component, inject, ViewChild } from '@angular/core';
import { ItemMode, MasterDataStatus, patchFormValue } from '../../../shared/shared.service';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { FormInputDynamicComponent } from '../../../shared/component/form-input-dynamic/form-input-dynamic.component';
import moment from 'moment/moment';
import { ProxyDynamicService } from '../../../shared/service/proxy-dynamic.service';

@Component({
  selector: 'app-owner-item',
  templateUrl: './item.component.html',
  styleUrl: './item.component.scss'
})
export class ItemComponent implements AfterViewInit {
  readonly nzModalData = inject(NZ_MODAL_DATA);
  formConfig = [];
  itemMode = ItemMode;
  @ViewChild('formModify') formModify!: FormInputDynamicComponent;

  constructor(
    private modal: NzModalRef,
    private service: ProxyDynamicService,
  ) {
    this.formConfig = this.nzModalData.formConfig;
  }

  ngAfterViewInit() {
    this.formModify.mode = this.nzModalData.mode;
    if (this.nzModalData.mode !== ItemMode.Add) {
      patchFormValue(this.formModify.formGroup, this.nzModalData.data);
      this.formModify.f['birthday'].setValue(this.nzModalData.data.birthday ? moment(this.nzModalData.data?.birthday, "YYYY-MM-DD").toDate() : null)
      this.formModify.f['issue_date'].setValue(this.nzModalData.data.issue_date ? moment(this.nzModalData.data?.date_created, "YYYY-MM-DD").toDate() : null)
      this.formModify.f['expired_date'].setValue(this.nzModalData.data.expired_date ? moment(this.nzModalData.data?.expired_date, "YYYY-MM-DD").toDate() : null)
      this.formModify.f['date_created'].setValue(this.nzModalData.data.date_created ? moment(this.nzModalData.data?.date_created, "YYYY-MM-DDTHH:mm:ss.SSSSZ").toDate() : null)
      this.formModify.f['date_updated'].setValue(this.nzModalData.data.date_updated ? moment(this.nzModalData.data?.date_updated, "YYYY-MM-DDTHH:mm:ss.SSSSZ").toDate() : null)
      if (this.nzModalData.mode === ItemMode.View) {
        this.formModify.formGroup.disable();
        this.service.count('service_card', {
          filter: {'butler_id': this.nzModalData.data.id, 'status': MasterDataStatus.Active}
        }).then(res => {
          this.formModify.f['card_quantity'].setValue(res);
        });

        this.service.search('apartment', {
          fields: ['code'], filter: {'butler_id': this.nzModalData.data.id, 'status': MasterDataStatus.Active}
        }).then(res => {
          if (res && res.length > 0) {
            this.formModify.f['apartment'].setValue(res.map((apartment: any) => apartment.code).join(', '));
          }
        });
      } else {
        if (this.nzModalData.mode === ItemMode.Edit) {
          this.formModify.formGroup.enable();
        }
      }
    }
  }

  edit() {
    this.formModify.mode = ItemMode.Edit;
    patchFormValue(this.formModify.formGroup, this.nzModalData.data);
    this.formModify.f['birthday'].setValue(this.nzModalData.data?.birthday ? moment(this.nzModalData.data?.birthday, "YYYY-MM-DD").toDate() : null)
    this.formModify.f['issue_date'].setValue(this.nzModalData.data?.issue_date ? moment(this.nzModalData.data?.date_created, "YYYY-MM-DD").toDate() : null)
    this.formModify.f['expired_date'].setValue(this.nzModalData.data?.expired_date ? moment(this.nzModalData.data?.expired_date, "YYYY-MM-DD").toDate() : null)
    this.formModify.f['date_created'].setValue(this.nzModalData.data?.date_created ? moment(this.nzModalData.data?.date_created, "YYYY-MM-DDTHH:mm:ss.SSSSZ").toDate() : null)
    this.formModify.f['date_updated'].setValue(this.nzModalData.data?.date_updated ? moment(this.nzModalData.data?.date_updated, "YYYY-MM-DDTHH:mm:ss.SSSSZ").toDate() : null)
    this.formModify.formGroup.enable();
  }

  destroyModal() {
    this.modal.destroy()
  }

  onSave() {
    this.formModify.collection = this.nzModalData.collection;
    this.formModify.onSave();
  }

  onSaveDone() {
    this.modal.destroy(true);
  }
}
